module.exports = __webpack_public_path__ + "img/cloth_g1_hat_14.9c728def.svg";